import {
    ApprovedIcon,
    ArchiveIcon,
    CompletedIcon,
    DesignPendingIcon,
    DesignedIcon,
    HoldIcon,
    InProgressIcon,
    ScheduledIcon,
    SubmittedIcon
} from "../icons";
import {
    Box,
    Typography
} from "@mui/material";

import { CustomIconProps } from "../icons/withCustomIcon";
import { ElementType } from "react";
import { IssueStatus } from "../../API";

type StatusDetails = {
    Icon: ElementType<CustomIconProps>;
    text: string;
    color?: any;
};

const STATUS_TO_DETAIL_MAP = new Map<IssueStatus, StatusDetails>(
    [
        [
            IssueStatus.SUBMITTED,
            {
                Icon: SubmittedIcon,
                text: "Submitted",
            }
        ],
        [
            IssueStatus.ARCHIVED,
            {
                Icon: ArchiveIcon,
                text: "Archived",
            }
        ],
        [
            IssueStatus.APPROVED,
            {
                Icon: ApprovedIcon,
                text: "Approved",
                color: "#388e3c"
            }
        ],
        [
            IssueStatus.ON_HOLD,
            {
                Icon: HoldIcon,
                text: "On Hold",
                color: "#F6DA51"
            }
        ],
        [
            IssueStatus.COMPLETED,
            {
                Icon: CompletedIcon,
                text: "Completed",
                color: "#388e3c"
            }
        ],
        [
            IssueStatus.IN_PROGRESS,
            {
                Icon: InProgressIcon,
                text: "In Progress",
                color: "#03A9F4"
            }
        ],
        [
            IssueStatus.DESIGN_PENDING,
            {
                Icon: DesignPendingIcon,
                text: "Design Pending",
                color: "#FFC107"
            }
        ],
        [
            IssueStatus.DESIGNED,
            {
                Icon: DesignedIcon,
                text: "Designed",
                color: "#388E3C"
            }
        ],
        [
            IssueStatus.SCHEDULED,
            {
                Icon: ScheduledIcon,
                text: "Scheduled",
                color: "#2196F3"
            }
        ],
    ]
);

export const IssueStatusDisplay = ({ status }: { status: IssueStatus; }) => {
    const statusDetails = STATUS_TO_DETAIL_MAP.get(status);

    return (
        <Box display="flex" alignItems="center" gap={1} sx={{ color: statusDetails?.color }}>
            {statusDetails?.Icon && (
                <statusDetails.Icon fontSize="small" accent="inherit"/>
            )}
            <Typography color="text.primary" fontSize="0.875rem">
                {statusDetails?.text}
            </Typography>
        </Box>
    );
};